import styled from "styled-components";

export const ContainerFluid = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f9fa;
  max-width: 100%;
  border-radius: 100% 0% 100% 0% / 100px;
`;

export const MainSection = styled.section`
  width: 90vw;
  margin: 5rem auto;
  max-width: 1170px;
  margin-top: 120px;
  @media screen and (min-width: 992px) {
    width: 95vw;
  }
`;

export const TitleDiv = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

export const CommonH2 = styled.h2`
  font-size: 2.5rem;
  line-height: 1;
  color: #495057;
  @media screen and (max-width: 768px) {
    font-size: 25px;
  }
`;

export const SectionCenter = styled.div`
  margin: 0 auto;
  margin-top: 4rem;
  width: 80vw;
  height: 650px;
  max-width: 800px;
  text-align: center;
  position: relative;
  display: flex;
  overflow: hidden;
`;

export const ProductImage = styled.img`
  border-radius: 10%;
  margin-bottom: 1rem;
  width: 150px;
  height: 230px;
  object-fit: cover;
  border: 4px solid 0 5px 15px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 991px) {
  }
`;

export const NameTitle = styled.h4`
  line-height: 1.25;
  margin-bottom: 0.75rem;
  font-size: 18px;
`;

export const CategoryPar = styled.p`
  margin-bottom: 1.25rem;
  color: #8d99ae;
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.5;
  font-size: 0.875rem;
`;

export const DescPar = styled.p`
  margin-bottom: 1.25rem;
  color: hsl(210, 22%, 49%);
  max-width: 35em;
  margin: 0 auto;
  margin-top: 2rem;
  line-height: 2;
  text-align: justify;
  text-justify: inter-word;
  color: #8d99ae;
  font-size: 0.875rem;
`;

export const PrevButton = styled.button`
  position: absolute;
  top: 200px;
  transform: translateY(-50%);
  background: var(--clr-grey-5);
  color: var(--clr-white);
  width: 1.25rem;
  height: 1.25rem;
  display: grid;
  place-items: center;
  border-color: transparent;
  font-size: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.3s linear;
  left: 0;

  @media (min-width: 800px) {
    width: 2rem;
    height: 2rem;
    font-size: 1.5rem;
  }
`;

export const NextButton = styled.button`
  position: absolute;
  top: 200px;
  transform: translateY(-50%);
  background: var(--clr-grey-5);
  color: var(--clr-white);
  width: 1.25rem;
  height: 1.25rem;
  display: grid;
  place-items: center;
  border-color: transparent;
  font-size: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.3s linear;
  right: 0;
  @media (min-width: 800px) {
    width: 2rem;
    height: 2rem;
    font-size: 1.5rem;
  }
`;
